import { apiClient } from '@/services/ApiClient.js'
export const allowedAppends = ['document_verification_activity']

export default {
  getFarmers(query) {
    return apiClient
      .get('farmers', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getFarmer(id) {
    return apiClient
      .get('farmers/' + id)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getInfo(tckn) {
    return apiClient
      .get('farmers/info/' + tckn)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  editFarmer(id, farmer) {
    return apiClient
      .patch('farmers/' + id, farmer)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  sendOtpForUpdatePhoneNumber(id, payload) {
    return apiClient
      .patch('farmers/' + id + '/update-phone-number/send-otp', payload)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  updatePhoneNumber(id, payload) {
    return apiClient
      .patch('farmers/' + id + '/update-phone-number/verify-otp-and-update', payload)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  checkPhoneNumber(id, payload) {
    return apiClient
      .post('farmers/' + id + '/update-phone-number/check-phone-number', payload)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  updateFarmerCksStatus(id, payload) {
    return apiClient
      .post('farmers/' + id + '/update-farmer-cks-status', payload)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getFarmerVerificationActivity(id) {
    return apiClient
      .get('farmers/' + id + '/verification-activity')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getStatistics(id) {
    return apiClient
      .get('farmers/' + id + '/statistics')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getGtsData(id) {
    return apiClient
      .get('farmers/' + id + '/gts')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  checkGtsData(id) {
    return apiClient
      .post('farmers/' + id + '/gts')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getCoupons(id) {
    return apiClient
      .get('farmers/' + id + '/coupons')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  removeCoupon(id, farmerId) {
    return apiClient
      .delete('farmers/' + farmerId + '/coupons/' + id)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  validatePhone(tckn, phone) {
    return apiClient
      .post('farmers/validate-phone', {
        phone: phone,
        tckn: tckn
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  checkPolicyAcceptance(tckn, phone) {
    return apiClient
      .post('farmers/check-policy-acceptance', {
        tckn,
        phone
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  verifyPolicyAcceptance(tckn, code) {
    return apiClient
      .post('farmers/verify-policy-acceptance', {
        tckn,
        code
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getPreviousGuaranteedApplications(farmerId, query) {
    return apiClient
      .get('farmers/' + farmerId + '/guaranteed-applications', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  checkGdprConsentDocumentByFarmerId(id) {
    return apiClient
      .get('farmers/check-gdpr-document-by-farmer/' + id)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  downloadGdprDocument(id) {
    return apiClient
      .get('farmers/download-gdpr-document/' + id, { responseType: 'arraybuffer' })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  removePreApprovedLimit(farmerId) {
    return apiClient
      .post('farmers/' + farmerId + '/cancel-pre-approved-limit')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getBlacklistHistory(farmerId) {
    return apiClient
      .get('farmers/' + farmerId + '/blacklist-history')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getActivityHistory(farmerId) {
    return apiClient
      .get('farmers/' + farmerId + '/activity-history')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  async inactivatePhoneNumber(farmerId) {
    return apiClient.patch(`farmers/${farmerId}/inactivate-phone-number`)
  },
  async fetchNetworkAnalysis(subjectType, subjectId, depth, dateRange = null) {
    const params = { subject_type: subjectType, subject_id: subjectId, depth: depth }

    if (dateRange !== null && Array.isArray(dateRange) && dateRange.length > 0) {
      params.start_date = dateRange[0]
      
      if (dateRange.length > 1) {
        params.end_date = dateRange[1]
      }
    }

    return apiClient.post('farmers/generate-device-network', params)
  }
}
